import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.css'],
})
export class ProfilePageComponent {
  lang: string = '';
  component: string = '';
  constructor(private route: ActivatedRoute) {
    this.route.params.subscribe((params) => {
      if (params) {
        this.lang = params['lang'];
        this.component = params['component'];
      }
    });
  }
}
